<template>
  <tr>
    <td class="v-align-middle">
      <ul>
        <li>Réservation ponctuelle client LENTREPRISE</li>
        <li>de 9h à 12h le 14/05/2016</li>
      </ul>
    </td>
    <td class="v-align-middle">
      <span>31/07/2016</span>
    </td>
    <td class="v-align-middle">
      <button class="btn btn-sm btn-complete">Détail</button>
    </td>
  </tr>
</template>

<style lang="scss" scoped>
      tr {
        td {
          height: 45px;
          &:nth-child(3) {
            width: 50px;
          }
        }
      }
</style>

<script type="text/babel">
  export default{}
</script>



// WEBPACK FOOTER //
// client/components/OneTimeLocations/OneTimeLocationsAskingsItem.vue